import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Authentication uses httpOnly cookies set by the backend on login.
// No token is stored in localStorage/sessionStorage — this prevents XSS token theft.
export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Ha ocurrido un error. Inténtalo de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const ROLE_COLORS = {
    fisioterapeuta: "#4A7C59",
    logopeda: "#5C80BC",
    nutricionista: "#F4A261",
    terapeuta_ocupacional: "#8D6A9F",
    neuropsicologo: "#E07A5F",
    psicologa: "#E29578",
    neurologo: "#2A3D45",
    geriatra: "#84A59D",
    directivo: "#2A3D45",
    admin: "#2A3D45",
    paciente: "#84A59D",
};

export const ROLE_LABELS = {
    fisioterapeuta: "Fisioterapeuta",
    logopeda: "Logopeda",
    nutricionista: "Nutricionista",
    terapeuta_ocupacional: "Terapeuta ocupacional",
    neuropsicologo: "Neuropsicólogo/a",
    psicologa: "Psicólogo/a",
    neurologo: "Neurólogo/a",
    geriatra: "Geriatra",
    directivo: "Directivo/a",
    admin: "Directivo/a",
    paciente: "Paciente",
    alumno: "Alumno (solo lectura)",
    coordinadora: "Coordinador/a",
    secretaria: "Secretaría",
    directora_entidad: "Directora de entidad",
};

export const isAlumno = (u) => u?.role === "alumno";
export const isReadOnly = (u) => u?.role === "alumno";
export const isSecretaria = (u) => u?.role === "secretaria";

export const PROFESSIONAL_ROLES = [
    "fisioterapeuta", "logopeda", "nutricionista", "terapeuta_ocupacional",
    "neuropsicologo", "psicologa", "neurologo", "geriatra", "coordinadora",
];
// Secretaría tiene casi todos los permisos del directivo; se ocultan cosas concretas en la UI.
export const isDirectivo = (u) => u?.role === "directivo" || u?.role === "admin" || u?.role === "secretaria";
export const isPatient = (u) => u?.role === "paciente";
// Directora de entidad: acceso completo SOLO a los pacientes de su entidad colaboradora.
export const isEntityDirector = (u) => u?.role === "directora_entidad";
export const isStaff = (u) => u && (isDirectivo(u) || PROFESSIONAL_ROLES.includes(u.role) || u.role === "profesional");
// Coordinador: por rol base o por permiso extra 'coordination' concedido por un directivo.
export const isCoordinator = (u) => !!u && (
    u.role === "coordinadora" ||
    u.role === "directivo" || u.role === "admin" ||
    (Array.isArray(u.extra_permissions) && u.extra_permissions.includes("coordination"))
);

export const isExternalPro = (u) => !!u
    && PROFESSIONAL_ROLES.includes(u.role)
    && u.employment_type !== "internal";

export const ROOMS = ["sala-1", "sala-2", "sala-3", "sala-4", "otro"];
export const REFERRAL_SOURCES = [
    "Google", "Instagram", "Facebook", "Recomendación paciente",
    "Recomendación médica", "Seguro médico", "Web propia", "Otro",
];
